import { jsx } from 'react/jsx-runtime';
import * as Sentry from '@sentry/browser';
import { ErrorBoundary as ErrorBoundary$1 } from '../../../../../../react-error-boundary/dist/react-error-boundary.esm.js';
import { Alert } from '../../../../../ui-components/dist/es/components/Alert/Alert.js';

const defaultText = 'There was an error. Please try again later. If the error persists please contact us.';
const defaultCloseButtonText = 'Retry';
const fallbackRender = (text, closeButtonText) => {
    const FallbackRenderComponent = ({ resetErrorBoundary }) => {
        return (jsx(Alert, { variant: "warning", closeButtonAriaLabel: closeButtonText, onClose: resetErrorBoundary, children: text }));
    };
    FallbackRenderComponent.displayName = 'FallbackRenderComponent';
    return FallbackRenderComponent;
};
const ErrorBoundary = ({ text = defaultText, closeButtonText = defaultCloseButtonText, showNotification = true, withSentryHub, children, }) => {
    const onError = (error, { componentStack }) => {
        const sentry = withSentryHub?.() ?? Sentry;
        sentry.withScope((scope) => {
            scope.setExtra('componentStack', componentStack);
            sentry.captureException(error);
        });
    };
    return (jsx(ErrorBoundary$1, { fallbackRender: showNotification ? fallbackRender(text, closeButtonText) : () => null, onError: onError, children: children }));
};
ErrorBoundary.displayName = 'ErrorBoundary';

export { ErrorBoundary };
//# sourceMappingURL=ErrorBoundary.js.map
